function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var RagProductDetail = /*#__PURE__*/function () {
  function RagProductDetail(element) {
    _classCallCheck(this, RagProductDetail);
    this.ragField = element.querySelector('.js-rag-input input');
    this.ragFieldProductCode = element.querySelector('.js-rag-inputProductCode');
    this.ragResponse = element.querySelector('.js-rag-response');
    this.ragSubmit = element.querySelector('.js-rag-buttonSubmit');
    this.ragClear = element.querySelector('.js-rag-buttonClear');
    this.ragFooter = element.querySelector('.js-rag-footer');
    this.ragNew = element.querySelector('.js-rag-buttonNew');
    this.ragNoResponse = element.querySelector('.js-rag-noResponse');
    this.queries = [];
  }
  return _createClass(RagProductDetail, [{
    key: "initRag",
    value: function initRag() {
      var _this = this;
      this.computeState();
      if (this.ragField && this.ragFieldProductCode && this.ragResponse) {
        this.ragField.addEventListener('input', function () {
          _this.computeState();
        });
        this.ragField.closest('form').addEventListener('submit', function (event) {
          event.preventDefault();
          if (_this.ragField.value.length === 0) {
            return;
          }
          var inputValue = encodeURIComponent(_this.ragField.value);
          var inputProductCodeValue = _this.ragFieldProductCode.value;
          _this.fetchNDJSON(_this.ragField.value, "/services/rag-productdetail?query=".concat(inputValue, "&productCode=").concat(inputProductCodeValue, "&previousQuery=").concat(_this.queries.join('previousQuery=')));
          _this.queries.push(inputValue);
        });
      }
      if (this.ragClear) {
        this.ragClear.addEventListener('click', function () {
          _this.ragField.value = '';
          _this.computeState();
        });
      }
      if (this.ragNew) {
        this.ragNew.addEventListener('click', function () {
          _this.ragField.value = '';
          _this.ragResponse.innerHTML = '';
          _this.queries = [];
          _this.computeState();
        });
      }
    }
  }, {
    key: "computeState",
    value: function computeState() {
      var isDisabled = !(this.ragField.value.length > 0);
      this.ragSubmit.disabled = isDisabled;
      this.ragFooter.classList.toggle('kl-hidden', !(this.queries.length > 0));
    }
  }, {
    key: "appendToDOM",
    value: function () {
      var _appendToDOM = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data, answerDiv) {
        var noResponse, newWords, index, _iterator, _step, word;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 300);
              });
            case 2:
              if (!(data.success === false)) {
                _context.next = 9;
                break;
              }
              noResponse = this.ragNoResponse.cloneNode(true);
              noResponse.classList.remove('kl-hidden');
              answerDiv.innerHTML = '';
              answerDiv.appendChild(noResponse);
              this.previousText = '';
              return _context.abrupt("return");
            case 9:
              if (data.answer) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              newWords = data.answer.slice(this.previousText.length).split(' ');
              index = 0;
              _iterator = _createForOfIteratorHelper(newWords);
              _context.prev = 14;
              _iterator.s();
            case 16:
              if ((_step = _iterator.n()).done) {
                _context.next = 25;
                break;
              }
              word = _step.value;
              _context.next = 20;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50 + Math.random() * 100);
              });
            case 20:
              answerDiv.textContent += word;
              if (index < newWords.length - 1) {
                answerDiv.textContent += ' ';
              }
              index++;
            case 23:
              _context.next = 16;
              break;
            case 25:
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](14);
              _iterator.e(_context.t0);
            case 30:
              _context.prev = 30;
              _iterator.f();
              return _context.finish(30);
            case 33:
              this.previousText = data.answer;
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[14, 27, 30, 33]]);
      }));
      function appendToDOM(_x, _x2) {
        return _appendToDOM.apply(this, arguments);
      }
      return appendToDOM;
    }()
  }, {
    key: "fetchNDJSON",
    value: function () {
      var _fetchNDJSON = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(query, url) {
        var response, responseDiv, queryDiv, answerDiv, reader, decoder, buffer, _yield$reader$read, done, value, lines, _iterator2, _step2, line, json, _json;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(url, {
                headers: {
                  'Accept': 'application/x-ndjson'
                }
              });
            case 2:
              response = _context2.sent;
              this.previousText = '';
              this.ragField.value = '';
              this.computeState();
              responseDiv = document.createElement('div');
              responseDiv.classList.add('m-ragProductDetailResponse');
              queryDiv = document.createElement('div');
              queryDiv.classList.add('m-ragProductDetailResponse__query');
              queryDiv.innerHTML = query;
              answerDiv = document.createElement('div');
              answerDiv.classList.add('m-ragProductDetailResponse__answer');
              responseDiv.appendChild(queryDiv);
              responseDiv.appendChild(answerDiv);
              this.ragResponse.appendChild(responseDiv);
              reader = response.body.getReader();
              decoder = new TextDecoder('utf-8');
              buffer = '';
            case 19:
              if (!true) {
                _context2.next = 58;
                break;
              }
              _context2.next = 22;
              return reader.read();
            case 22:
              _yield$reader$read = _context2.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              if (!done) {
                _context2.next = 27;
                break;
              }
              return _context2.abrupt("break", 58);
            case 27:
              buffer += decoder.decode(value, {
                stream: true
              });
              lines = buffer.split('\n');
              buffer = lines.pop();
              _iterator2 = _createForOfIteratorHelper(lines);
              _context2.prev = 31;
              _iterator2.s();
            case 33:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 48;
                break;
              }
              line = _step2.value;
              if (!(line.trim() === '')) {
                _context2.next = 37;
                break;
              }
              return _context2.abrupt("continue", 46);
            case 37:
              _context2.prev = 37;
              json = JSON.parse(line);
              _context2.next = 41;
              return this.appendToDOM(json, answerDiv);
            case 41:
              _context2.next = 46;
              break;
            case 43:
              _context2.prev = 43;
              _context2.t0 = _context2["catch"](37);
              console.error('RAG invalid:', line, _context2.t0);
            case 46:
              _context2.next = 33;
              break;
            case 48:
              _context2.next = 53;
              break;
            case 50:
              _context2.prev = 50;
              _context2.t1 = _context2["catch"](31);
              _iterator2.e(_context2.t1);
            case 53:
              _context2.prev = 53;
              _iterator2.f();
              return _context2.finish(53);
            case 56:
              _context2.next = 19;
              break;
            case 58:
              if (!buffer.trim()) {
                _context2.next = 68;
                break;
              }
              _context2.prev = 59;
              _json = JSON.parse(buffer);
              _context2.next = 63;
              return this.appendToDOM(_json, answerDiv);
            case 63:
              _context2.next = 68;
              break;
            case 65:
              _context2.prev = 65;
              _context2.t2 = _context2["catch"](59);
              console.error('Last line RAG invalid:', buffer, _context2.t2);
            case 68:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[31, 50, 53, 56], [37, 43], [59, 65]]);
      }));
      function fetchNDJSON(_x3, _x4) {
        return _fetchNDJSON.apply(this, arguments);
      }
      return fetchNDJSON;
    }()
  }]);
}();
export default RagProductDetail;